// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable/Clickable";
import Icon from "@insite/mobius/Icon";
import Search from "@werner/XDL/Icons/Search";
import { mergeWithCss } from "@werner/XDL/Utilities";
import React, { FC, useState } from "react";

interface OwnProps {
    isShow?: boolean;
    onClick?: React.EventHandler<React.MouseEvent>;
    extendedStyles?: HeaderSearchClickableStyles;
}

interface HeaderSearchClickableStyles {
    searchClickable?: ClickablePresentationProps;
}

const headerSearchClickableStyles: HeaderSearchClickableStyles = {};

const HeaderSearchClickable: FC<OwnProps> = ({ isShow, onClick, extendedStyles }) => {
    const [styles] = useState(() => mergeWithCss(headerSearchClickableStyles, extendedStyles));
    return (
        <Clickable {...styles.searchClickable} onClick={onClick} aria-label="header-search">
            <Icon src={Search} size={22} color={isShow ? "primary" : "common.ui3"} />
        </Clickable>
    );
};

export default HeaderSearchClickable;
